import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * AppDataService
 *
 * @export
 */
@Injectable({
  providedIn: 'root',
})
export class AppDataService {

  /**
   * iOS bundle name for smartDogTrainer
   */
  smartDogTrainer = 'com.radiosystems.petsafe.smartdogtrainer';

  /**
   * iOS bundle name for smartDogTrainer
   */
  myPetsafe = 'net.petsafe.platform';

  /**
   * iOS AppStore lookup url
   */
  iosAppDataURL = 'https://itunes.apple.com/lookup';

  /**
   * Creates an instance of AppDataService.
   * @param http HttpClient
   */
  constructor(private http: HttpClient) {}

  /**
   * Returns metadata from the iOS AppStore for a given app bundle
   *
   * @param  bundle id that identifies the bundle that we want to fetch
   * @returns meta data from storepage
   */
  public getAppStoreData(bundle: string): Observable<any> {
    return this.http.get<any>(`${this.iosAppDataURL}?bundleId=${bundle}`);
  }
}
